import Model from '../Model';
import {OrmConfig} from "@/pcm/types/vuex/OrmConfig";
import Category from "@/pcm/store/models/Category";
import Tag from "@/pcm/store/models/Tag";
import Contract from "@/pcm/store/models/Contract";
import Network from "@/pcm/store/models/Network";
import Company from "@/pcm/store/models/Company";
import MediaView from './MediaView';
import Client from "@/pcm/store/models/Client";

export default class Media extends Model {
    static entity = 'media';

    static apiConfig: OrmConfig = {
        model: this.entity,
        name_prop: 'name',
    };

    static fields() {
        return {
            id: this.uid(),
            model_id: this.uid(),
            uuid: this.string(''),
            name: this.string(''),
            file_name: this.string(''),
            mime_type: this.string(''),
            size: this.string(''),
            extension: this.string(''),
            human_readable_size: this.string(''),
            original_url: this.string(''),
            collection_name: this.string(''),
            mux_signed_status: this.string(null).nullable(),
            mux_signed_playback_id: this.string(null).nullable(),
            mux_signed_data: this.attr(null).nullable(),
            mux_public_status: this.string(null).nullable(),
            mux_public_playback_id: this.string(null).nullable(),
            mux_public_data: this.attr(null).nullable(),
            audio_processed: this.boolean(false),
            is_thematic: this.boolean(false),
            is_trending: this.boolean(false),
            is_configured: this.boolean(false),
            is_muted: this.boolean(false),
            audio_url: this.string(null).nullable(),
            video_url: this.string(null).nullable(),

            thumbnail_token: this.attr(null),
            thumbnail_token_gif: this.attr(null),
            is_favorite: this.boolean(false),
            is_downloaded: this.boolean(false),

            created_at: this.string(''),
            updated_at: this.string(''),

            categories: this.attr([]),
            networks: this.attr([]),
            tags: this.attr([]),
            companies: this.attr([]),
            model: this.attr(null),
            views: this.attr(null),
            client_favorites: this.attr([]),
        }
    }

    declare id: number;
    declare model_id: number;
    declare uuid: string;
    declare name: string;
    declare file_name: string;
    declare mime_type: string;
    declare size: string;
    declare extension: string;
    declare audio_url: string | null;
    declare human_readable_size: string;
    declare original_url: string;
    declare collection_name: string;
    declare mux_signed_status: string | null;
    declare mux_signed_playback_id: string | null;
    declare mux_signed_data: string | null;
    declare mux_public_status: string | null;
    declare mux_public_playback_id: string | null;
    declare mux_public_data: string | null | any;
    declare audio_processed: boolean;
    declare is_thematic: boolean;
    declare is_trending: boolean;
    declare is_configured: boolean;
    declare is_muted: boolean;
    declare categories: Array<Category>;
    declare tags: Array<Tag>;
    declare contract: Contract;
    declare model: Contract;
    declare networks: Network[];
    declare companies: Company[];
    declare views: MediaView;
    declare is_favorite: boolean;
    declare is_downloaded: boolean;
}
